import { Col, Section } from '@guestyci/foundation/Layout';
import Placeholder from '@guestyci/foundation/Placeholder';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    placeholderChild: {
      width: '100%',
      height: '4.375rem',
    },
    placeholderContainer: {
      width: '680px',
      padding: '2rem .8rem',
      margin: '0 auto',
      backgroundColor: 'white',
      '& > * ': {
        marginBottom: '15px',
      },
    },
    section: {
      backgroundColor: '#fafafa',
      padding: '0 !important',
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center',
    },
  },
  { name: 'Iframe-placeholder' }
);

export default function IframePlaceholder() {
  const classes = useStyles();

  return (
    <Section className={classes.section}>
      <Col className={`${classes.placeholderContainer} preload-container`}>
        <Placeholder className={classes.placeholderChild} />
        <Placeholder className={classes.placeholderChild} />
        <Placeholder className={classes.placeholderChild} />
        <Placeholder className={classes.placeholderChild} />
        <Placeholder className={classes.placeholderChild} />
      </Col>
    </Section>
  );
}
